module.exports = __webpack_public_path__ + "static/JannonText-9595feb37befd39c19a3185ac2805ed7.woff";